<template>
  <div class="container" v-loading="loading">
    <div style="margin: 10px 20px; font-weight: bolder; color: #333333; font-size: 30px;">
      QTUNE
      <span v-if="isRuning" style="color: #67C23A; font-size: 16px">(正在调参)</span>
      <span v-else style="color: #909399; font-size: 16px">(未运行)</span>
    </div>
    <el-card style="display: flex; flex-direction: column; margin: 0 20px;">
      <div style="display: flex; flex-direction: row; align-items: center; justify-content: space-between; margin-bottom: 10px">
        <div style="font-size: 16px; color: #666666;">可以在此修改配置文件</div>
        <div style="font-size: 14px; color: #409EFF; cursor: pointer;" @click="onHistoryClick">历史结果</div>
      </div>
      <div style="width: calc(100vw - 100px); display: flex; flex-direction: row; height: calc(96vh - 120px);">
        <div style="display: flex; flex-direction: column; justify-content: space-between; width: 45%; height: 100%; margin-right: 20px">
          <div style="display:flex; flex-direction: row; align-items: center; height: calc(100% - 50px);; width: 100%">
            <el-input
                class="input"
                type="textarea"
                resize="none"
                style="height: 100%; width: 100%"
                placeholder="Please enter the sqls you want to get index."
                v-model="config">
            </el-input>
          </div>
          <div style="display: flex; flex-direction: row; justify-content: space-between;">
            <div/>
            <div>
              <el-button :disabled="!config" type="warning" plain @click="onSaveClick">保存</el-button>
              <el-button v-if="!isRuning" type="success" plain @click="onRunClick">运行</el-button>
              <el-button v-else type="danger" plain @click="onStopClick">停止</el-button>
            </div>
          </div>
        </div>
        <div style="width: 55%; height: calc(100% - 50px); background: white; overflow-y: auto">
          <div style="font-size: 14px; margin: 5px 0; color: #67C23A">预期结果曲线：运行时间({{parseTime(currentRunTime)}})</div>
          <div style="position: relative; height: 100px; width: 100%; background: #f9f9f9; border-radius: 4px; z-index: 1">
            <VChart class="lineChart" :option="predictLineChartOption"/>
          </div>
          <div style="display: flex; flex-direction: row; justify-content: end; margin-top: 5px">
            <span style="font-size: 12px; color: #999999">点击图表可获取每个点的参数值</span>
          </div>
          <div style="font-size: 14px; margin: 5px 0; color: #999999">执行日志：</div>
          <div class="log-container" id="log-container" style="height: calc(100% - 202px);">
            {{ log }}
          </div>
        </div>
      </div>
    </el-card>

    <el-dialog
        center
        title="历史结果"
        :visible.sync="historyDialogVisible"
        width="80%"
        v-loading="historyLoading"
    >
      <div style="display: flex; flex-direction: column; position: relative">
        <div v-if="historyData.length > 0" style="display: flex; flex-direction: row; flex-wrap: wrap; align-items: center;">
          <div
              class="history-time-item"
              v-for="(item, index) in historyData"
              :key="index"
              :style="historyIndex === index ? 'background: #409EFF; color: #ffffff' : ''"
              @click="onHistoryItemClick(item,index)">
            {{parseTime(item['random'].time_at)}}
          </div>
        </div>
        <div style="font-size: 14px; margin: 5px 0; color: #67C23A">预期结果曲线</div>
        <div style="position: relative; height: 200px; width: 100%; background: #f9f9f9; border-radius: 4px; z-index: 1">
          <VChart class="history-line-chart" :option="historyPredictLineChartOption"/>
        </div>
        <div style="display: flex; flex-direction: row; justify-content: end; margin-top: 5px">
          <span style="font-size: 12px; color: #999999">点击图表可获取每个点的参数值</span>
        </div>
      </div>
    </el-dialog>


  </div>
</template>

<script>

import {runStatus, startRun, runLog, configContent, modifiyConfigContent, stopRun, currentTuneRes, historyTuneRes} from '@/api/api'
import {use} from 'echarts/core'
import {SVGRenderer} from 'echarts/renderers'
import {LineChart} from 'echarts/charts'
import {TooltipComponent, TitleComponent, GridComponent} from 'echarts/components'
import {default as VChart, THEME_KEY} from 'vue-echarts'
import {predictChartOption, randomChartOption} from "@/assets/data";
import {parseTime} from "@/utils/utils";

use([
  SVGRenderer,
  LineChart,
  TooltipComponent,
  TitleComponent,
  GridComponent
])

export default {
  name: 'Index',
  components: {
    VChart,
  },
  provide: {
    [THEME_KEY]: 'light'
  },
  data() {
    return {
      config: '',
      isRuning: false,
      log: "",
      predictLineChartOption: JSON.parse(JSON.stringify(predictChartOption)),
      randomLineChartOption: JSON.parse(JSON.stringify(randomChartOption)),
      historyPredictLineChartOption: JSON.parse(JSON.stringify(predictChartOption)),
      historyRandomLineChartOption: JSON.parse(JSON.stringify(randomChartOption)),
      loading: false,
      historyLoading: false,
      logTimer: undefined,
      runStatusTimer: undefined,
      currentRunTime: '',
      currentPredictParameters: [],
      currentRandomParameters: [],
      historyDialogVisible: false,
      historyData: [],
      historyIndex: -1,
      historyPredictParameters: [],
      historyRandomParameters: [],
    }
  },
  watch: {
    isRuning: {
      handler: function() {
        if (this.isRuning) {
          if (!this.runStatusTimer) {
            const that = this
            this.runStatusTimer = setInterval(() => {
              that.getRunStatus()
            }, 5000)
          }
        }else {
          if (this.runStatusTimer) {
            clearInterval(this.runStatusTimer)
          }
        }
      },
      immediate: true
    }
  },
  destroyed() {
    if (this.logTimer) {
      clearInterval(this.logTimer)
    }
    if (this.runStatusTimer) {
      clearInterval(this.runStatusTimer)
    }
  },
  mounted() {
    this.getRunStatus()
    this.getRunLog()
    this.getCurrentTuneRes()
    this.getConfigContent()

    const that = this
    // this.randomLineChartOption.tooltip.formatter = function(params, ticket, callback) {
    //   var result = '训练轮数：' + params[0].axisValueLabel + '</br>'
    //   const param = params[0]
    //   result += `${param.marker}&nbspQPS:&nbsp ${param.value}</br>`
    //   const parameter = that.currentRandomParameters[param.dataIndex]
    //   for (var key in parameter) {
    //     result += `${key}&nbsp=&nbsp ${parameter[key]}</br>`
    //   }
    //   result += '<div style="color: #409EFF; margin-top: 5px; font-size: 12px; cursor: pointer" class="random-copy-button" onclick="'
    //       + that.onParamsCopyClick("random-copy-button", parameter) + '">点击复制参数</div>'
    //   setTimeout(function() {
    //     callback(ticket, result)
    //   }, 100)
    //   return 'loading...'
    // }

    this.predictLineChartOption.tooltip.formatter = function(params, ticket, callback) {
      var result = '训练轮数：' + params[0].axisValueLabel + '</br>'
      const param = params[0]
      result += `${param.marker}&nbspQPS:&nbsp ${param.value}</br>`
      const parameter = that.currentPredictParameters[param.dataIndex]
      for (var key in parameter) {
        result += `${key}&nbsp=&nbsp ${parameter[key]}</br>`
      }
      result += '<div style="color: #409EFF; margin-top: 5px; font-size: 12px; cursor: pointer" class="predict-copy-button" onclick="'
          + that.onParamsCopyClick("predict-copy-button", parameter) + '">点击复制参数</div>'
      setTimeout(function() {
        callback(ticket, result)
      }, 100)
      return 'loading...'
    }

    // this.historyRandomLineChartOption.tooltip.formatter = function(params, ticket, callback) {
    //   var result = '训练轮数：' + params[0].axisValueLabel + '</br>'
    //   const param = params[0]
    //   result += `${param.marker}&nbspQPS:&nbsp ${param.value}</br>`
    //   const parameter = that.historyRandomParameters[param.dataIndex]
    //   for (var key in parameter) {
    //     result += `${key}&nbsp=&nbsp ${parameter[key]}</br>`
    //   }
    //   result += '<div style="color: #409EFF; margin-top: 5px; font-size: 12px; cursor: pointer" class="history-random-copy-button" onclick="'
    //       + that.onParamsCopyClick("history-random-copy-button", parameter) + '">点击复制参数</div>'
    //   setTimeout(function() {
    //     callback(ticket, result)
    //   }, 100)
    //   return 'loading...'
    // }

    this.historyPredictLineChartOption.tooltip.formatter = function(params, ticket, callback) {
      var result = '训练轮数：' + params[0].axisValueLabel + '</br>'
      const param = params[0]
      result += `${param.marker}&nbspQPS:&nbsp ${param.value}</br>`
      const parameter = that.historyPredictParameters[param.dataIndex]
      for (var key in parameter) {
        result += `${key}&nbsp=&nbsp ${parameter[key]}</br>`
      }
      result += '<div style="color: #409EFF; margin-top: 5px; font-size: 12px; cursor: pointer" class="history-predict-copy-button" onclick="'
          + that.onParamsCopyClick("history-predict-copy-button", parameter) + '">点击复制参数</div>'
      setTimeout(function() {
        callback(ticket, result)
      }, 100)
      return 'loading...'
    }

  },
  methods: {
    parseTime(time) {
      return parseTime(time)
    },
    onSaveClick() {
      modifiyConfigContent({content: this.config}).then(res => {
        console.log(res)
        this.$message.success("保存成功")
      })
    },
    onRunClick() {
      this.loading = true
      startRun().then(res => {
        this.loading = false
        if (res.data.status) {
          this.$message.success("运行成功")
        }else {
          this.$message.error("运行失败，请检查运行参数")
        }
        this.isRuning = res.data.status
        this.getRunLog()
      }).catch(() => {
        this.loading = false
      })
    },
    onStopClick() {
      this.$confirm('此操作将停止调参, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.loading = true
        stopRun().then(res => {
          if (!res.data.status) {
            this.$message.success("已经停止")
          }else {
            this.$message.error("停止失败，请再次点击")
          }
          this.loading = false
        }).catch(() => {
          this.loading = false
        })
      }).catch(() => {});
    },
    onHistoryClick() {

      this.historyPredictLineChartOption.xAxis.data = []
      this.historyPredictLineChartOption.series[0].data = []

      this.historyRandomLineChartOption.xAxis.data = []
      this.historyRandomLineChartOption.series[0].data = []

      this.historyDialogVisible = true
      this.historyLoading = true

      historyTuneRes().then(res => {
        this.historyLoading = false
        this.historyData = res.data
        this.onHistoryItemClick(this.historyData[0], 0)
      }).catch(() => {
        this.historyLoading = false
      })
    },
    onParamsCopyClick(className, item) {
      const that = this
      this.$nextTick(() => {
        setTimeout(() => {
          let obj1 = document.getElementsByClassName(className)[0];
          obj1.addEventListener('click', function () {
            that.$copyText(JSON.stringify(item)).then(function () {
              that.$message.success(' 已经复制到剪贴板！')
            }, function () {
              that.$message.error('复制失败，请重新复制！')
            })
          });
        }, 200)
      });
    },
    getRunStatus() {
      runStatus().then(res => {
        this.isRuning = res.data.status
        if (this.isRuning) {
          if (!this.logTimer) {
            const that = this
            this.logTimer = setInterval(() => {
              that.getRunLog()
              that.getCurrentTuneRes()
            }, 2000)
          }
        }else {
          if (this.logTimer) {
            clearInterval(this.logTimer)
          }
        }
      })
    },
    getRunLog() {
      runLog().then(res => {
        this.log = res.data.content
        var div = document.getElementById('log-container');
        if (div){
          div.scrollTop = div.scrollHeight;
        }
      })
    },
    getCurrentTuneRes() {
      currentTuneRes().then(res => {
        var predictData = res.data['predict']?.data
        var predictxAxisData = []
        var predictSeriesData = []
        this.currentPredictParameters = []
        for (let i = 0; i < predictData.length; i++) {
          predictxAxisData.push(predictData[i].index)
          predictSeriesData.push(predictData[i].qps)
          this.currentPredictParameters.push(predictData[i].parameter)
        }
        this.predictLineChartOption.xAxis.data = predictxAxisData
        this.predictLineChartOption.series[0].data = predictSeriesData

        var randomData = res.data['random']?.data
        var randomxAxisData = []
        var randomSeriesData = []
        this.currentRandomParameters = []
        for (let i = 0; i < randomData.length; i++) {
          randomxAxisData.push(randomData[i].index)
          randomSeriesData.push(randomData[i].qps)
          this.currentRandomParameters.push(randomData[i].parameter)
        }
        this.randomLineChartOption.xAxis.data = randomxAxisData
        this.randomLineChartOption.series[0].data = randomSeriesData

        this.currentRunTime = res.data['random']?.time_at
      }).catch(() => {})
    },
    getConfigContent() {
      configContent().then(res => {
        this.config = res.data.content
      })
    },
    onHistoryItemClick(item, index) {
      this.historyIndex = index
      var predictData = item['predict']?.data
      var predictxAxisData = []
      var predictSeriesData = []
      this.historyPredictParameters = []
      for (let i = 0; i < predictData.length; i++) {
        predictxAxisData.push(predictData[i].index)
        predictSeriesData.push(predictData[i].qps)
        this.historyPredictParameters.push(predictData[i].parameter)
      }
      this.historyPredictLineChartOption.xAxis.data = predictxAxisData
      this.historyPredictLineChartOption.series[0].data = predictSeriesData

      var randomData = item['random']?.data
      var randomxAxisData = []
      var randomSeriesData = []
      this.historyRandomParameters = []
      for (let i = 0; i < randomData.length; i++) {
        randomxAxisData.push(randomData[i].index)
        randomSeriesData.push(randomData[i].qps)
        this.historyRandomParameters.push(randomData[i].parameter)
      }
      this.historyRandomLineChartOption.xAxis.data = randomxAxisData
      this.historyRandomLineChartOption.series[0].data = randomSeriesData
    }
  }
}
</script>

<style>


.input .el-textarea__inner {
  height: 100%;
  width: 100%;
  background: #000000;
  color: #ffffff;
  font-size: 14px;
}

.el-textarea.is-disabled .el-textarea__inner {
  background-color: #666666 !important;
  color: lawngreen !important;
}

.v-modal{
  opacity: 0.4!important;
  background: rgba(0,0,0,0.4)!important;
}

.lineChart >> svg {
  z-index: -1!important;
}


</style>

<style scoped>

.container {
  display: flex;
  flex-direction: column;
  width: 100vw;
  height: 100%;
  margin: 0;
  padding: 0;
  overflow: hidden;
}

.lineChart {
  width: 100%;
  height: 100px;
  z-index: 0;
}

.history-line-chart {
  width: 100%;
  height: 200px;
  z-index: 0;
}

.history-time-item {
  padding: 5px 10px;
  color: #409EFF;
  cursor: pointer;
  border: 1px solid #409EFF;
  border-radius: 8px;
  margin-right: 10px;
  margin-bottom: 10px;
  background: white;
}

.log-container {
  width: calc(100% - 20px);
  background: #666666;
  color: #ffffff;
  border-radius: 4px;
  padding: 10px;
  font-size: 12px;
  overflow-y: auto;
  white-space: pre-wrap;
}

</style>


